<div class="overlay-loader" *ngIf="isLoading">
  <div class="spinner-box">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
</div>

<ng-container *ngIf="purchaseOrders$ | async as purchaseOrders">
  <div class="no-record" *ngIf="!purchaseOrders.length">
    No records found
  </div>
  <div class="orders-container" *ngIf="purchaseOrders.length">
    <mat-card>
      <mat-card-title>Purchase Orders</mat-card-title>
      <mat-card-content>

        <table mat-table [dataSource]="purchaseOrders | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
          class="mat-elevation-z2 orders-table">

          <ng-container matColumnDef="slno">
            <th mat-header-cell *matHeaderCellDef> Sl No. </th>
            <td mat-cell *matCellDef="let order; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
          </ng-container>

          <ng-container matColumnDef="purchase_id">
            <th mat-header-cell *matHeaderCellDef> Number </th>
            <td mat-cell *matCellDef="let order">
              <a [routerLink]="['/order-details', order.purchase_id]" class="po-link">
                {{ order.name }}
              </a>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="purchase_report_data">
            <th mat-header-cell *matHeaderCellDef>Download</th>
            <td mat-cell *matCellDef="let order">
              <button mat-icon-button color="primary"
                (click)="downloadBase64File(order.purchase_report_data, order.name)">
                <mat-icon>download</mat-icon>
              </button>
            </td>
          </ng-container> -->

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let order"> {{ order.date | date:'dd-MM-yyyy' }} </td>
          </ng-container>

          <ng-container matColumnDef="amount_untaxed">
            <th mat-header-cell *matHeaderCellDef> Value </th>
            <td mat-cell *matCellDef="let order"> {{order.currency}} {{ order.amount_due }} </td>
          </ng-container>

          <ng-container matColumnDef="bill_status">
            <th mat-header-cell *matHeaderCellDef> Bill Status </th>
            <td mat-cell *matCellDef="let order"> {{ order.bill_status }} </td>
          </ng-container>

          <ng-container matColumnDef="filename">
            <th mat-header-cell *matHeaderCellDef>Upload File</th>
            <td mat-cell *matCellDef="let order">
              <a class="po-link" href="javascript:void(0)" (click)="openAttachDialog(order)">
                Upload
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="billno">
            <th mat-header-cell *matHeaderCellDef>View Files</th>
            <td mat-cell *matCellDef="let order">
              <a class="po-link" href="javascript:void(0)" (click)="openViewAttachDialog(order)">
                View
              </a>
            </td>
          </ng-container>          

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [length]="purchaseOrders.length" *ngIf="purchaseOrders.length > 5" [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
</ng-container>